import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Global routing behavior: every forward navigation to a new route opens at the
// top of the page. Preserves browser back/forward restoration (POP) and lets
// in-page anchor (#hash) links jump to their target instead of forcing the top.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === "POP") return; // let the browser restore the previous scroll
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, navType]);

  return null;
}
